import React from 'react';
import PageHeader from '../components/layout/PageHeader';
import Accordion, { AccordionItem } from '../components/ui/Accordion';
import { UsersIcon, CalendarIcon, MailIcon, PhoneIcon, ClipboardCheckIcon, HandIcon, HeartIcon, BriefcaseIcon } from 'lucide-react';
import Button from '../components/ui/Button';
const PTA = () => {
  return <div className="min-h-screen bg-white" data-id="element-5905">
      <PageHeader title="Parent-Teacher Association" description="The PTA serves as a vital link between parents and the school, working together to enhance the educational experience of our students." backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/jdfoyTCXLviMyjmi5MDX1X/WhatsApp_Image_2025-10-24_at_11.30.13.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'PTA',
      path: '/pta'
    }]} data-id="element-5906" />
      <div className="container mx-auto px-4 py-12" data-id="element-5907">
        {/* Introduction Section */}
        <section className="mb-16" data-id="element-5908">
          <div className="text-center mb-10" data-id="element-5909">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5910">
              Welcome to the IGS Parent-Teacher Association
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5911"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5912">
              Working together to create a supportive environment for our
              students' academic and personal growth.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-5913">
            <div data-id="element-5914">
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-5915">
                The Parent-Teacher Association (PTA) of Isonyin Grammar School
                is a collaborative body of parents, guardians, and teachers
                dedicated to enhancing the educational experience of our
                students. We believe that when parents and teachers work
                together, students benefit tremendously.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-5916">
                Our PTA serves as a vital communication channel between the home
                and school, ensuring that parents are informed about school
                activities and policies, while also providing a platform for
                parents to contribute to the school's development.
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-5917">
                Through regular meetings, events, and volunteer opportunities,
                the PTA fosters a sense of community and shared responsibility
                for the education and welfare of our students. We invite all
                parents and guardians to actively participate in the PTA and
                contribute to making Isonyin Grammar School an even better place
                for our children.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-5918">
              <div className="bg-blue-50 p-6 rounded-lg hover:shadow-md transition-shadow" data-id="element-5919">
                <div className="flex items-center mb-3" data-id="element-5920">
                  <UsersIcon className="h-6 w-6 text-blue-700 mr-2" data-id="element-5921" />
                  <h3 className="font-bold text-blue-900" data-id="element-5922">
                    Community Building
                  </h3>
                </div>
                <p className="text-gray-700 text-sm" data-id="element-5923">
                  Creating a strong network of parents, teachers, and
                  administrators
                </p>
              </div>
              <div className="bg-blue-50 p-6 rounded-lg hover:shadow-md transition-shadow" data-id="element-5924">
                <div className="flex items-center mb-3" data-id="element-5925">
                  <ClipboardCheckIcon className="h-6 w-6 text-blue-700 mr-2" data-id="element-5926" />
                  <h3 className="font-bold text-blue-900" data-id="element-5927">Academic Support</h3>
                </div>
                <p className="text-gray-700 text-sm" data-id="element-5928">
                  Enhancing educational experiences through resources and
                  programs
                </p>
              </div>
              <div className="bg-blue-50 p-6 rounded-lg hover:shadow-md transition-shadow" data-id="element-5929">
                <div className="flex items-center mb-3" data-id="element-5930">
                  <HandIcon className="h-6 w-6 text-blue-700 mr-2" data-id="element-5931" />
                  <h3 className="font-bold text-blue-900" data-id="element-5932">
                    Volunteer Services
                  </h3>
                </div>
                <p className="text-gray-700 text-sm" data-id="element-5933">
                  Organizing volunteers for school events and activities
                </p>
              </div>
              <div className="bg-blue-50 p-6 rounded-lg hover:shadow-md transition-shadow" data-id="element-5934">
                <div className="flex items-center mb-3" data-id="element-5935">
                  <HeartIcon className="h-6 w-6 text-blue-700 mr-2" data-id="element-5936" />
                  <h3 className="font-bold text-blue-900" data-id="element-5937">Student Welfare</h3>
                </div>
                <p className="text-gray-700 text-sm" data-id="element-5938">
                  Promoting the well-being and safety of all students
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* PTA Leadership Section */}
        <section className="mb-16" data-id="element-5939">
          <div className="text-center mb-10" data-id="element-5940">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5941">
              PTA Leadership
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5942"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5943">
              Meet the dedicated parents and teachers who lead our PTA.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-5944">
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5945">
              <div className="w-full h-56 bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center" data-id="element-5946">
                <UsersIcon className="h-24 w-24 text-blue-700" data-id="element-5947" />
              </div>
              <div className="p-6" data-id="element-5948">
                <h3 className="text-xl font-bold text-blue-900" data-id="element-5949">
                  Mrs. Abimbola Olatunji
                </h3>
                <p className="text-blue-700 mb-3" data-id="element-5950">PTA Chairperson</p>
                <p className="text-gray-700 mb-4" data-id="element-5951">
                  A dedicated parent with three children at IGS. Mrs. Olatunji
                  has been actively involved in the PTA for 5 years and is
                  committed to strengthening the partnership between parents and
                  the school.
                </p>
                <div className="flex items-center text-gray-600 text-sm mb-2" data-id="element-5952">
                  <MailIcon className="h-4 w-4 mr-2" data-id="element-5953" />
                  <span data-id="element-5954">pta.chair@isonyingrammarschool.edu.ng</span>
                </div>
                <div className="flex items-center text-gray-600 text-sm" data-id="element-5955">
                  <PhoneIcon className="h-4 w-4 mr-2" data-id="element-5956" />
                  <span data-id="element-5957">+234 (0) 803 456 7890</span>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5958">
              <div className="w-full h-56 bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center" data-id="element-5959">
                <UsersIcon className="h-24 w-24 text-blue-700" data-id="element-5960" />
              </div>
              <div className="p-6" data-id="element-5961">
                <h3 className="text-xl font-bold text-blue-900" data-id="element-5962">
                  Mr. Emmanuel Adeyemi
                </h3>
                <p className="text-blue-700 mb-3" data-id="element-5963">PTA Vice Chairperson</p>
                <p className="text-gray-700 mb-4" data-id="element-5964">
                  A parent of two IGS students and a business executive. Mr.
                  Adeyemi brings his organizational skills and leadership
                  experience to support the PTA's initiatives.
                </p>
                <div className="flex items-center text-gray-600 text-sm mb-2" data-id="element-5965">
                  <MailIcon className="h-4 w-4 mr-2" data-id="element-5966" />
                  <span data-id="element-5967">pta.vicechair@isonyingrammarschool.edu.ng</span>
                </div>
                <div className="flex items-center text-gray-600 text-sm" data-id="element-5968">
                  <PhoneIcon className="h-4 w-4 mr-2" data-id="element-5969" />
                  <span data-id="element-5970">+234 (0) 805 678 9012</span>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5971">
              <div className="w-full h-56 bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center" data-id="element-5972">
                <UsersIcon className="h-24 w-24 text-blue-700" data-id="element-5973" />
              </div>
              <div className="p-6" data-id="element-5974">
                <h3 className="text-xl font-bold text-blue-900" data-id="element-5975">
                  Mrs. Chioma Nwosu
                </h3>
                <p className="text-blue-700 mb-3" data-id="element-5976">PTA Secretary</p>
                <p className="text-gray-700 mb-4" data-id="element-5977">
                  A teacher at IGS and parent of a former student. Mrs. Nwosu
                  provides valuable insights from both the parent and teacher
                  perspectives, helping to bridge communication gaps.
                </p>
                <div className="flex items-center text-gray-600 text-sm mb-2" data-id="element-5978">
                  <MailIcon className="h-4 w-4 mr-2" data-id="element-5979" />
                  <span data-id="element-5980">pta.secretary@isonyingrammarschool.edu.ng</span>
                </div>
                <div className="flex items-center text-gray-600 text-sm" data-id="element-5981">
                  <PhoneIcon className="h-4 w-4 mr-2" data-id="element-5982" />
                  <span data-id="element-5983">+234 (0) 807 890 1234</span>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-blue-50 p-8 rounded-lg border border-blue-100" data-id="element-5984">
            <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-5985">
              Executive Committee
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5986">
              <div data-id="element-5987">
                <h4 className="font-bold text-blue-900 mb-3" data-id="element-5988">
                  Parent Representatives
                </h4>
                <ul className="space-y-3" data-id="element-5989">
                  <li className="flex items-start" data-id="element-5990">
                    <UsersIcon className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-5991" />
                    <div data-id="element-5992">
                      <p className="font-bold" data-id="element-5993">Dr. Oluwasegun Adeyemi</p>
                      <p className="text-sm text-gray-600" data-id="element-5994">
                        JSS Representative
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-5995">
                    <UsersIcon className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-5996" />
                    <div data-id="element-5997">
                      <p className="font-bold" data-id="element-5998">Mrs. Folake Ogunleye</p>
                      <p className="text-sm text-gray-600" data-id="element-5999">
                        SSS Representative
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-6000">
                    <UsersIcon className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-6001" />
                    <div data-id="element-6002">
                      <p className="font-bold" data-id="element-6003">Mr. Taiwo Adesina</p>
                      <p className="text-sm text-gray-600" data-id="element-6004">
                        Boarding House Representative
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-6005">
                    <BriefcaseIcon className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-6006" />
                    <div data-id="element-6007">
                      <p className="font-bold" data-id="element-6008">Mrs. Victoria Olatunji</p>
                      <p className="text-sm text-gray-600" data-id="element-6009">Treasurer</p>
                    </div>
                  </li>
                </ul>
              </div>
              <div data-id="element-6010">
                <h4 className="font-bold text-blue-900 mb-3" data-id="element-6011">
                  School Representatives
                </h4>
                <ul className="space-y-3" data-id="element-6012">
                  <li className="flex items-start" data-id="element-6013">
                    <UsersIcon className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-6014" />
                    <div data-id="element-6015">
                      <p className="font-bold" data-id="element-6016">Dr. Oluwasegun Adeyemi</p>
                      <p className="text-sm text-gray-600" data-id="element-6017">Principal</p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-6018">
                    <UsersIcon className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-6019" />
                    <div data-id="element-6020">
                      <p className="font-bold" data-id="element-6021">Mrs. Folake Ogunleye</p>
                      <p className="text-sm text-gray-600" data-id="element-6022">
                        Vice Principal (Academics)
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-6023">
                    <UsersIcon className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-6024" />
                    <div data-id="element-6025">
                      <p className="font-bold" data-id="element-6026">Mr. Oluwaseyi Johnson</p>
                      <p className="text-sm text-gray-600" data-id="element-6027">
                        Teacher Representative (JSS)
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-6028">
                    <UsersIcon className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-6029" />
                    <div data-id="element-6030">
                      <p className="font-bold" data-id="element-6031">Ms. Abiola Oladipo</p>
                      <p className="text-sm text-gray-600" data-id="element-6032">
                        Teacher Representative (SSS)
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/* PTA Initiatives Section */}
        <section className="mb-16" data-id="element-6033">
          <div className="text-center mb-10" data-id="element-6034">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-6035">
              PTA Initiatives & Achievements
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-6036"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-6037">
              Discover the various ways our PTA contributes to the school
              community.
            </p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-6038">
            <div data-id="element-6039">
              <h3 className="text-2xl font-bold text-blue-900 mb-6" data-id="element-6040">
                Recent Achievements
              </h3>
              <div className="space-y-6" data-id="element-6041">
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-6042">
                  <div className="flex items-center mb-3" data-id="element-6043">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-700 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-6044">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-6045" />
                    </svg>
                    <h4 className="text-lg font-bold text-blue-900" data-id="element-6046">
                      Computer Lab Renovation
                    </h4>
                  </div>
                  <p className="text-gray-700 mb-2" data-id="element-6047">
                    The PTA successfully raised funds to renovate and upgrade
                    the school's computer laboratory, providing 25 new computers
                    and modern furniture.
                  </p>
                  <div className="text-sm text-gray-600" data-id="element-6048">
                    <span className="font-medium" data-id="element-6049">Completed:</span> August 2022
                  </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-6050">
                  <div className="flex items-center mb-3" data-id="element-6051">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-700 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-6052">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-6053" />
                    </svg>
                    <h4 className="text-lg font-bold text-blue-900" data-id="element-6054">
                      Scholarship Program
                    </h4>
                  </div>
                  <p className="text-gray-700 mb-2" data-id="element-6055">
                    Established a scholarship fund that currently supports 10
                    academically gifted students from financially disadvantaged
                    backgrounds.
                  </p>
                  <div className="text-sm text-gray-600" data-id="element-6056">
                    <span className="font-medium" data-id="element-6057">Launched:</span> January 2022
                  </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-6058">
                  <div className="flex items-center mb-3" data-id="element-6059">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-700 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-6060">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-6061" />
                    </svg>
                    <h4 className="text-lg font-bold text-blue-900" data-id="element-6062">
                      Teacher Appreciation Program
                    </h4>
                  </div>
                  <p className="text-gray-700 mb-2" data-id="element-6063">
                    Initiated an annual Teacher Appreciation Week with special
                    events and awards to recognize the dedication and hard work
                    of our teaching staff.
                  </p>
                  <div className="text-sm text-gray-600" data-id="element-6064">
                    <span className="font-medium" data-id="element-6065">Annual Event:</span> First
                    week of October
                  </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-6066">
                  <div className="flex items-center mb-3" data-id="element-6067">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-700 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-6068">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-6069" />
                    </svg>
                    <h4 className="text-lg font-bold text-blue-900" data-id="element-6070">
                      Library Enhancement
                    </h4>
                  </div>
                  <p className="text-gray-700 mb-2" data-id="element-6071">
                    Organized a book drive that collected over 1,000 books to
                    expand the school library's collection, particularly in the
                    areas of science, technology, and literature.
                  </p>
                  <div className="text-sm text-gray-600" data-id="element-6072">
                    <span className="font-medium" data-id="element-6073">Completed:</span> March 2023
                  </div>
                </div>
              </div>
            </div>
            <div data-id="element-6074">
              <h3 className="text-2xl font-bold text-blue-900 mb-6" data-id="element-6075">
                Ongoing Initiatives
              </h3>
              <div className="bg-blue-900 text-white p-6 rounded-lg mb-6" data-id="element-6076">
                <h4 className="text-xl font-bold mb-4" data-id="element-6077">
                  Infrastructure Development Project
                </h4>
                <p className="mb-4" data-id="element-6078">
                  The PTA is currently fundraising for several infrastructure
                  improvements:
                </p>
                <ul className="space-y-3" data-id="element-6079">
                  <li className="flex items-start" data-id="element-6080">
                    <div className="h-5 w-5 text-yellow-400 mr-2" data-id="element-6081">✓</div>
                    <p data-id="element-6082">
                      Construction of a covered walkway between academic blocks
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-6083">
                    <div className="h-5 w-5 text-yellow-400 mr-2" data-id="element-6084">✓</div>
                    <p data-id="element-6085">
                      Renovation of the school auditorium with modern
                      audiovisual equipment
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-6086">
                    <div className="h-5 w-5 text-yellow-400 mr-2" data-id="element-6087">✓</div>
                    <p data-id="element-6088">
                      Installation of solar panels to provide alternative power
                      supply
                    </p>
                  </li>
                </ul>
                <div className="mt-4" data-id="element-6089">
                  <p className="mb-2" data-id="element-6090">Fundraising Progress:</p>
                  <div className="w-full bg-blue-800 rounded-full h-4" data-id="element-6091">
                    <div className="bg-yellow-500 h-4 rounded-full" style={{
                    width: '65%'
                  }} data-id="element-6092"></div>
                  </div>
                  <div className="flex justify-between text-sm mt-1" data-id="element-6093">
                    <span data-id="element-6094">₦6.5M raised</span>
                    <span data-id="element-6095">₦10M goal</span>
                  </div>
                </div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md mb-6" data-id="element-6096">
                <h4 className="text-xl font-bold text-blue-900 mb-4" data-id="element-6097">
                  Academic Support Programs
                </h4>
                <ul className="space-y-3" data-id="element-6098">
                  <li className="flex items-start" data-id="element-6099">
                    <div className="h-5 w-5 text-blue-700 mr-2" data-id="element-6100">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-6101">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-6102" />
                      </svg>
                    </div>
                    <div data-id="element-6103">
                      <p className="font-bold" data-id="element-6104">After-School Tutoring</p>
                      <p className="text-sm text-gray-700" data-id="element-6105">
                        Volunteer parents and teachers provide additional
                        academic support in core subjects
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-6106">
                    <div className="h-5 w-5 text-blue-700 mr-2" data-id="element-6107">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-6108">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-6109" />
                      </svg>
                    </div>
                    <div data-id="element-6110">
                      <p className="font-bold" data-id="element-6111">Career Mentorship</p>
                      <p className="text-sm text-gray-700" data-id="element-6112">
                        Connecting students with professionals in various fields
                        for guidance and inspiration
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-6113">
                    <div className="h-5 w-5 text-blue-700 mr-2" data-id="element-6114">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-6115">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-6116" />
                      </svg>
                    </div>
                    <div data-id="element-6117">
                      <p className="font-bold" data-id="element-6118">Educational Workshops</p>
                      <p className="text-sm text-gray-700" data-id="element-6119">
                        Organizing workshops on study skills, exam preparation,
                        and digital literacy
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="bg-yellow-50 p-6 rounded-lg border border-yellow-100" data-id="element-6120">
                <div className="flex items-center mb-4" data-id="element-6121">
                  <CalendarIcon className="h-6 w-6 text-yellow-600 mr-3" data-id="element-6122" />
                  <h4 className="text-lg font-bold text-blue-900" data-id="element-6123">
                    Upcoming PTA Project
                  </h4>
                </div>
                <p className="text-gray-700 mb-4" data-id="element-6124">
                  The PTA is planning to establish a Student Wellness Center
                  that will provide:
                </p>
                <ul className="space-y-2 text-gray-700" data-id="element-6125">
                  <li className="flex items-center" data-id="element-6126">
                    <div className="h-2 w-2 bg-yellow-500 rounded-full mr-2" data-id="element-6127"></div>
                    <span data-id="element-6128">
                      Counseling services for academic and personal issues
                    </span>
                  </li>
                  <li className="flex items-center" data-id="element-6129">
                    <div className="h-2 w-2 bg-yellow-500 rounded-full mr-2" data-id="element-6130"></div>
                    <span data-id="element-6131">Health education programs</span>
                  </li>
                  <li className="flex items-center" data-id="element-6132">
                    <div className="h-2 w-2 bg-yellow-500 rounded-full mr-2" data-id="element-6133"></div>
                    <span data-id="element-6134">Stress management and mental health support</span>
                  </li>
                </ul>
                <div className="mt-4 text-sm text-gray-600" data-id="element-6135">
                  <span className="font-medium" data-id="element-6136">Target Launch:</span> January
                  2024
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Meetings & Events Section */}
        <section className="mb-16" data-id="element-6137">
          <div className="text-center mb-10" data-id="element-6138">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-6139">
              Meetings & Events
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-6140"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-6141">
              Stay informed about upcoming PTA meetings and events.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-6142">
            <div data-id="element-6143">
              <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-6144">
                Regular Meetings
              </h3>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-6145">
                <p className="text-gray-700 mb-4" data-id="element-6146">
                  The PTA holds regular general meetings throughout the academic
                  year. All parents, guardians, and teachers are encouraged to
                  attend these meetings to stay informed and contribute to
                  discussions.
                </p>
                <div className="overflow-x-auto" data-id="element-6147">
                  <table className="min-w-full bg-white" data-id="element-6148">
                    <thead data-id="element-6149">
                      <tr className="bg-blue-900 text-white" data-id="element-6150">
                        <th className="py-2 px-4 text-left" data-id="element-6151">Meeting Type</th>
                        <th className="py-2 px-4 text-left" data-id="element-6152">Frequency</th>
                        <th className="py-2 px-4 text-left" data-id="element-6153">Typical Agenda</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200" data-id="element-6154">
                      <tr data-id="element-6155">
                        <td className="py-2 px-4 font-medium" data-id="element-6156">
                          General Assembly
                        </td>
                        <td className="py-2 px-4" data-id="element-6157">Once per term</td>
                        <td className="py-2 px-4" data-id="element-6158">
                          School updates, financial reports, major initiatives
                        </td>
                      </tr>
                      <tr className="bg-gray-50" data-id="element-6159">
                        <td className="py-2 px-4 font-medium" data-id="element-6160">
                          Executive Committee
                        </td>
                        <td className="py-2 px-4" data-id="element-6161">Monthly</td>
                        <td className="py-2 px-4" data-id="element-6162">
                          Planning, budget reviews, issue resolution
                        </td>
                      </tr>
                      <tr data-id="element-6163">
                        <td className="py-2 px-4 font-medium" data-id="element-6164">
                          Class Representatives
                        </td>
                        <td className="py-2 px-4" data-id="element-6165">Bi-monthly</td>
                        <td className="py-2 px-4" data-id="element-6166">
                          Class-specific concerns, event coordination
                        </td>
                      </tr>
                      <tr className="bg-gray-50" data-id="element-6167">
                        <td className="py-2 px-4 font-medium" data-id="element-6168">
                          Annual General Meeting
                        </td>
                        <td className="py-2 px-4" data-id="element-6169">Once per year</td>
                        <td className="py-2 px-4" data-id="element-6170">
                          Annual reports, elections, strategic planning
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div data-id="element-6171">
              <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-6172">
                Upcoming Events
              </h3>
              <div className="space-y-4" data-id="element-6173">
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-6174">
                  <div className="flex" data-id="element-6175">
                    <div className="mr-4" data-id="element-6176">
                      <div className="bg-blue-100 text-blue-900 font-bold rounded p-3 text-center min-w-[70px]" data-id="element-6177">
                        <div className="text-lg" data-id="element-6178">15</div>
                        <div className="text-xs" data-id="element-6179">OCT</div>
                      </div>
                    </div>
                    <div data-id="element-6180">
                      <h4 className="font-bold text-blue-900 mb-1" data-id="element-6181">
                        First Term General Meeting
                      </h4>
                      <div className="flex items-center text-gray-600 text-sm mb-2" data-id="element-6182">
                        <ClockIcon className="h-4 w-4 mr-1" data-id="element-6183" />
                        <span data-id="element-6184">3:00 PM - 5:00 PM</span>
                        <span className="mx-2" data-id="element-6185">•</span>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-6186">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" data-id="element-6187" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-6188" />
                        </svg>
                        <span data-id="element-6189">School Auditorium</span>
                      </div>
                      <p className="text-gray-700 text-sm" data-id="element-6190">
                        Welcome address, introduction of new parents,
                        presentation of first term activities, and budget
                        approval.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-6191">
                  <div className="flex" data-id="element-6192">
                    <div className="mr-4" data-id="element-6193">
                      <div className="bg-blue-100 text-blue-900 font-bold rounded p-3 text-center min-w-[70px]" data-id="element-6194">
                        <div className="text-lg" data-id="element-6195">05</div>
                        <div className="text-xs" data-id="element-6196">NOV</div>
                      </div>
                    </div>
                    <div data-id="element-6197">
                      <h4 className="font-bold text-blue-900 mb-1" data-id="element-6198">
                        Career Day
                      </h4>
                      <div className="flex items-center text-gray-600 text-sm mb-2" data-id="element-6199">
                        <ClockIcon className="h-4 w-4 mr-1" data-id="element-6200" />
                        <span data-id="element-6201">9:00 AM - 2:00 PM</span>
                        <span className="mx-2" data-id="element-6202">•</span>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-6203">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" data-id="element-6204" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-6205" />
                        </svg>
                        <span data-id="element-6206">School Hall</span>
                      </div>
                      <p className="text-gray-700 text-sm" data-id="element-6207">
                        Parent professionals from various fields will share
                        insights about their careers with students. Volunteer
                        speakers needed!
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-6208">
                  <div className="flex" data-id="element-6209">
                    <div className="mr-4" data-id="element-6210">
                      <div className="bg-blue-100 text-blue-900 font-bold rounded p-3 text-center min-w-[70px]" data-id="element-6211">
                        <div className="text-lg" data-id="element-6212">18</div>
                        <div className="text-xs" data-id="element-6213">NOV</div>
                      </div>
                    </div>
                    <div data-id="element-6214">
                      <h4 className="font-bold text-blue-900 mb-1" data-id="element-6215">
                        PTA Fundraising Dinner
                      </h4>
                      <div className="flex items-center text-gray-600 text-sm mb-2" data-id="element-6216">
                        <ClockIcon className="h-4 w-4 mr-1" data-id="element-6217" />
                        <span data-id="element-6218">6:00 PM - 9:00 PM</span>
                        <span className="mx-2" data-id="element-6219">•</span>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-6220">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" data-id="element-6221" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-6222" />
                        </svg>
                        <span data-id="element-6223">Golden Tulip Hotel</span>
                      </div>
                      <p className="text-gray-700 text-sm" data-id="element-6224">
                        Annual fundraising dinner to support the Infrastructure
                        Development Project. Tickets available from class
                        representatives.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-6225">
                  <div className="flex" data-id="element-6226">
                    <div className="mr-4" data-id="element-6227">
                      <div className="bg-blue-100 text-blue-900 font-bold rounded p-3 text-center min-w-[70px]" data-id="element-6228">
                        <div className="text-lg" data-id="element-6229">09</div>
                        <div className="text-xs" data-id="element-6230">DEC</div>
                      </div>
                    </div>
                    <div data-id="element-6231">
                      <h4 className="font-bold text-blue-900 mb-1" data-id="element-6232">
                        End of Term Family Fun Day
                      </h4>
                      <div className="flex items-center text-gray-600 text-sm mb-2" data-id="element-6233">
                        <ClockIcon className="h-4 w-4 mr-1" data-id="element-6234" />
                        <span data-id="element-6235">10:00 AM - 4:00 PM</span>
                        <span className="mx-2" data-id="element-6236">•</span>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-6237">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" data-id="element-6238" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-6239" />
                        </svg>
                        <span data-id="element-6240">School Sports Ground</span>
                      </div>
                      <p className="text-gray-700 text-sm" data-id="element-6241">
                        A day of games, food, and entertainment for the entire
                        school community. Volunteers needed for various roles.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* FAQ Section */}
        <section className="mb-16" data-id="element-6242">
          <div className="text-center mb-10" data-id="element-6243">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-6244">
              Frequently Asked Questions
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-6245"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-6246">
              Common questions about the PTA and parent involvement at IGS.
            </p>
          </div>
          <div className="max-w-3xl mx-auto" data-id="element-6247">
            <Accordion variant="bordered" data-id="element-6248">
              <AccordionItem title="How can I join the PTA?" defaultOpen data-id="element-6249">
                <p className="text-gray-700 mb-4" data-id="element-6250">
                  All parents and guardians of current IGS students, as well as
                  all teaching staff, are automatically members of the PTA.
                  There is no formal registration process required to join.
                </p>
                <p className="text-gray-700 mb-4" data-id="element-6251">
                  To become an active member, simply:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 mt-2" data-id="element-6252">
                  <li data-id="element-6253">Attend PTA meetings</li>
                  <li data-id="element-6254">Volunteer for PTA activities and events</li>
                  <li data-id="element-6255">Contribute to PTA initiatives</li>
                  <li data-id="element-6256">
                    Consider running for a position on the Executive Committee
                    during elections
                  </li>
                </ul>
              </AccordionItem>
              <AccordionItem title="What is the PTA fee and how is it used?" data-id="element-6257">
                <p className="text-gray-700 mb-4" data-id="element-6258">
                  The annual PTA fee is ₦5,000 per family, regardless of the
                  number of children enrolled at IGS. This fee is included in
                  the school fees and is collected at the beginning of each
                  academic year.
                </p>
                <p className="text-gray-700 mb-4" data-id="element-6259">
                  The PTA fee is used to fund various initiatives and
                  activities, including:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700" data-id="element-6260">
                  <li data-id="element-6261">Infrastructure development and maintenance projects</li>
                  <li data-id="element-6262">Educational resources and equipment</li>
                  <li data-id="element-6263">Student welfare programs</li>
                  <li data-id="element-6264">Teacher appreciation events</li>
                  <li data-id="element-6265">PTA-sponsored scholarships</li>
                  <li data-id="element-6266">Administrative costs of running the PTA</li>
                </ul>
                <p className="mt-4 text-gray-700" data-id="element-6267">
                  A detailed financial report is presented at each general
                  meeting and at the Annual General Meeting.
                </p>
              </AccordionItem>
              <AccordionItem title="How can I volunteer for PTA activities?" data-id="element-6268">
                <p className="text-gray-700 mb-4" data-id="element-6269">
                  There are many ways to volunteer with the PTA, depending on
                  your interests, skills, and availability. Some volunteer
                  opportunities include:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700" data-id="element-6270">
                  <li data-id="element-6271">
                    Serving on committees (e.g., Fundraising, Events, Academic
                    Support)
                  </li>
                  <li data-id="element-6272">Helping organize and run events</li>
                  <li data-id="element-6273">
                    Providing professional expertise for specific projects
                  </li>
                  <li data-id="element-6274">Mentoring students in your area of expertise</li>
                  <li data-id="element-6275">Assisting with communication and publicity</li>
                </ul>
                <p className="mt-4 text-gray-700" data-id="element-6276">To volunteer, you can:</p>
                <ul className="list-disc list-inside space-y-2 text-gray-700" data-id="element-6277">
                  <li data-id="element-6278">Speak to any Executive Committee member</li>
                  <li data-id="element-6279">
                    Email{' '}
                    <span className="text-blue-700" data-id="element-6280">
                      pta@isonyingrammarschool.edu.ng
                    </span>
                  </li>
                  <li data-id="element-6281">
                    Fill out the volunteer form available at the school office
                  </li>
                  <li data-id="element-6282">Sign up during PTA meetings</li>
                </ul>
              </AccordionItem>
              <AccordionItem title="How are PTA Executive Committee members elected?" data-id="element-6283">
                <p className="text-gray-700 mb-4" data-id="element-6284">
                  The PTA Executive Committee is elected every two years at the
                  Annual General Meeting, typically held at the end of the third
                  term. The election process is as follows:
                </p>
                <ol className="list-decimal list-inside space-y-2 text-gray-700" data-id="element-6285">
                  <li data-id="element-6286">Nominations are opened one month before the AGM</li>
                  <li data-id="element-6287">
                    Interested candidates submit their nominations for specific
                    positions
                  </li>
                  <li data-id="element-6288">Candidates may give brief speeches at the AGM</li>
                  <li data-id="element-6289">
                    Elections are conducted by secret ballot during the AGM
                  </li>
                  <li data-id="element-6290">
                    Results are announced and new officers are inaugurated
                  </li>
                </ol>
                <p className="mt-4 text-gray-700" data-id="element-6291">
                  To be eligible for election, a candidate must:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700" data-id="element-6292">
                  <li data-id="element-6293">
                    Be a parent/guardian of a current IGS student or a teacher
                    at IGS
                  </li>
                  <li data-id="element-6294">
                    Have been an active PTA member for at least one academic
                    year
                  </li>
                  <li data-id="element-6295">Be nominated and seconded by current PTA members</li>
                </ul>
              </AccordionItem>
              <AccordionItem title="How does the PTA communicate with parents?" data-id="element-6296">
                <p className="text-gray-700 mb-4" data-id="element-6297">
                  The PTA uses multiple channels to communicate with parents and
                  ensure everyone stays informed:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700" data-id="element-6298">
                  <li data-id="element-6299">Email newsletters sent monthly</li>
                  <li data-id="element-6300">
                    WhatsApp groups for each class, managed by class
                    representatives
                  </li>
                  <li data-id="element-6301">
                    Notices on the school's physical and digital notice boards
                  </li>
                  <li data-id="element-6302">
                    Letters sent home with students for important announcements
                  </li>
                  <li data-id="element-6303">SMS alerts for urgent information</li>
                  <li data-id="element-6304">Updates during PTA meetings</li>
                  <li data-id="element-6305">Dedicated section on the school website</li>
                </ul>
                <p className="mt-4 text-gray-700" data-id="element-6306">
                  To ensure you receive all communications, please make sure
                  your contact information is up to date with both the school
                  office and your class representative.
                </p>
              </AccordionItem>
            </Accordion>
          </div>
        </section>
        {/* Get Involved Section */}
        <section data-id="element-6307">
          <div className="bg-blue-900 text-white rounded-lg overflow-hidden" data-id="element-6308">
            <div className="container mx-auto px-4 py-12" data-id="element-6309">
              <div className="text-center mb-8" data-id="element-6310">
                <h2 className="text-3xl font-bold mb-4" data-id="element-6311">Get Involved</h2>
                <p className="max-w-2xl mx-auto" data-id="element-6312">
                  Your involvement makes a difference! Join us in creating the
                  best possible educational environment for our children.
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-6313">
                <div className="bg-blue-800/50 p-6 rounded-lg backdrop-blur-sm border border-blue-700/50" data-id="element-6314">
                  <div className="flex items-center mb-4" data-id="element-6315">
                    <div className="p-3 bg-blue-700/50 rounded-full mr-3" data-id="element-6316">
                      <CalendarIcon className="h-6 w-6 text-yellow-400" data-id="element-6317" />
                    </div>
                    <h3 className="text-xl font-bold" data-id="element-6318">Attend Meetings</h3>
                  </div>
                  <p className="mb-4" data-id="element-6319">
                    Stay informed and contribute to discussions by attending
                    regular PTA meetings.
                  </p>
                  <Button href="/pta/calendar" variant="outline" size="sm" className="border-white text-white hover:bg-white/10" data-id="element-6320">
                    View Meeting Schedule
                  </Button>
                </div>
                <div className="bg-blue-800/50 p-6 rounded-lg backdrop-blur-sm border border-blue-700/50" data-id="element-6321">
                  <div className="flex items-center mb-4" data-id="element-6322">
                    <div className="p-3 bg-blue-700/50 rounded-full mr-3" data-id="element-6323">
                      <HandIcon className="h-6 w-6 text-yellow-400" data-id="element-6324" />
                    </div>
                    <h3 className="text-xl font-bold" data-id="element-6325">Volunteer</h3>
                  </div>
                  <p className="mb-4" data-id="element-6326">
                    Share your time and talents to support school activities and
                    PTA initiatives.
                  </p>
                  <Button href="/pta/volunteer" variant="outline" size="sm" className="border-white text-white hover:bg-white/10" data-id="element-6327">
                    Volunteer Opportunities
                  </Button>
                </div>
                <div className="bg-blue-800/50 p-6 rounded-lg backdrop-blur-sm border border-blue-700/50" data-id="element-6328">
                  <div className="flex items-center mb-4" data-id="element-6329">
                    <div className="p-3 bg-blue-700/50 rounded-full mr-3" data-id="element-6330">
                      <HeartIcon className="h-6 w-6 text-yellow-400" data-id="element-6331" />
                    </div>
                    <h3 className="text-xl font-bold" data-id="element-6332">Donate</h3>
                  </div>
                  <p className="mb-4" data-id="element-6333">
                    Support our projects through financial contributions or
                    in-kind donations.
                  </p>
                  <Button href="/pta/donate" variant="outline" size="sm" className="border-white text-white hover:bg-white/10" data-id="element-6334">
                    Support Our Initiatives
                  </Button>
                </div>
              </div>
              <div className="text-center" data-id="element-6335">
                <p className="mb-6" data-id="element-6336">
                  Have questions or suggestions? We'd love to hear from you!
                </p>
                <Button href="mailto:pta@isonyingrammarschool.edu.ng" variant="primary" size="lg" data-id="element-6337">
                  Contact the PTA
                </Button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>;
};
export default PTA;